(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          offset: 0,
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
        });

        $(window).on('load', function() {
          AOS.refreshHard();
        });

        function initFilterPanels(options) {
          var transitionDuration = options.transitionDuration || 450;
          var blockSelector = options.block;
          var filterSelector = options.filter;
          var panelsSelector = options.panel;
          var panelsContainerSelector = options.panelsContainer;
          var indexAttr = options.indexAttr;
          var timerDataKey = options.timerDataKey;
          var dataSelectorPrefix = '[data-' + indexAttr + '="';

          function getIndexSelector(index) {
            return dataSelectorPrefix + index + '"]';
          }

          function setActivePanel($block, index) {
            var $filters = $block.find(filterSelector);
            var $panelsContainer = $block.find(panelsContainerSelector);
            var $panels = $block.find(panelsSelector);
            var $activePanel = $panels.filter('.active');
            var $nextPanel = $panels.filter(getIndexSelector(index));
            var hideTimer = $block.data(timerDataKey);
            var currentHeight;
            var nextHeight;

            if (!$nextPanel.length || $nextPanel.is($activePanel)) {
              return;
            }

            if (hideTimer) {
              window.clearTimeout(hideTimer);
            }

            $panels
              .not($activePanel)
              .not($nextPanel)
              .removeClass('active is-switching')
              .attr('aria-hidden', 'true')
              .attr('hidden', true);

            $filters
              .removeClass('active')
              .attr('aria-selected', 'false')
              .attr('tabindex', '-1');

            $filters
              .filter(getIndexSelector(index))
              .addClass('active')
              .attr('aria-selected', 'true')
              .attr('tabindex', '0');

            currentHeight = $panelsContainer.hasClass('is-transitioning') ? $panelsContainer.outerHeight() : $activePanel.outerHeight(true);

            $panelsContainer
              .css('height', currentHeight)
              .addClass('is-transitioning');

            $activePanel.addClass('is-switching');

            $nextPanel
              .removeClass('active')
              .addClass('is-switching')
              .attr('aria-hidden', 'false')
              .removeAttr('hidden');

            nextHeight = $nextPanel.outerHeight(true);
            $panelsContainer[0].offsetHeight;

            $activePanel
              .removeClass('active')
              .attr('aria-hidden', 'true');

            $nextPanel.addClass('active');
            $panelsContainer.css('height', nextHeight);

            hideTimer = window.setTimeout(function () {
              $panels
                .not($nextPanel)
                .removeClass('active is-switching')
                .attr('aria-hidden', 'true')
                .attr('hidden', true);

              $nextPanel.removeClass('is-switching');
              $panelsContainer.removeClass('is-transitioning').css('height', '');
              $block.removeData(timerDataKey);
            }, transitionDuration);

            $block.data(timerDataKey, hideTimer);
          }

          function focusFilter($filters, index) {
            var $target = $filters.filter(getIndexSelector(index));

            if ($target.length) {
              $target.trigger('focus');
            }
          }

          $(function () {
            $(blockSelector).each(function () {
              var $block = $(this);
              var $filters = $block.find(filterSelector);

              if (!$filters.length) {
                return;
              }

              setActivePanel($block, 0);

              $block.on('click', filterSelector, function () {
                setActivePanel($block, $(this).data(indexAttr));
              });

              $block.on('keydown', filterSelector, function (event) {
                var currentIndex = $(this).data(indexAttr);
                var lastIndex = $filters.length - 1;
                var nextIndex;

                if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                  nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                  nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
                } else if (event.key === 'Home') {
                  nextIndex = 0;
                } else if (event.key === 'End') {
                  nextIndex = lastIndex;
                } else {
                  return;
                }

                event.preventDefault();
                setActivePanel($block, nextIndex);
                focusFilter($filters, nextIndex);
              });
            });
          });
        }

        function scrollActiveIntoView($scroller, $active, $anchor, options) {
          var settings = $.extend({
            duration: 280,
            mediaQuery: '(max-width: 991.98px)',
            snapAfter: false
          }, options);
          var activeRect;
          var scrollerRect;
          var anchorRect;
          var activeOffset;
          var anchorOffset;
          var targetLeft;

          if (
            !$scroller.length ||
            !$active.length ||
            !$anchor.length ||
            !window.matchMedia(settings.mediaQuery).matches
          ) {
            return;
          }

          activeRect = $active[0].getBoundingClientRect();
          scrollerRect = $scroller[0].getBoundingClientRect();
          anchorRect = $anchor[0].getBoundingClientRect();
          activeOffset = activeRect.left - scrollerRect.left + $scroller.scrollLeft();
          anchorOffset = anchorRect.left - scrollerRect.left;
          targetLeft = activeOffset - anchorOffset;

          $scroller.stop().animate({ scrollLeft: targetLeft }, settings.duration, function () {
            if (settings.snapAfter) {
              $scroller.scrollLeft(targetLeft);
            }
          });
        }

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
          $('.js-navbar-collapse').toggleClass('active');
        });


        jQuery(function ($) {
          const $stickyTop = $('.js-sticky-top');

          function updateStickyHeader() {
            const scrollTop =
              window.pageYOffset ||
              document.documentElement.scrollTop ||
              0;

            $stickyTop.toggleClass('float', scrollTop > 200);
          }

          // Set the correct state immediately.
          updateStickyHeader();

          $(window).on('scroll resize load pageshow', function () {
            window.requestAnimationFrame(updateStickyHeader);
          });
        });
      


        //////////////////////////////////////////////////////////////////////////////////////
        // Dropdown hover
        //////////////////////////////////////////////////////////////////////////////////////
        jQuery(function($) {

          ////////////////////////////////////////////////////////////////////////////
          // Desktop hover
          ////////////////////////////////////////////////////////////////////////////
          $('.navbar-nav > li.dropdown').hover(
            function() {
              if (window.innerWidth >= 1200) {
                var $item = $(this);
                var $wrapper = $item.children('.js-dropdown-menu-wrapper');

                // Close other top-level dropdowns.
                $item
                  .siblings('.dropdown')
                  .removeClass('hover')
                  .children('.js-dropdown-menu-wrapper')
                  .stop(true, true)
                  .hide();

                // Add hover only to the current <li>.
                $item.addClass('hover');

                // Open only the wrapper belonging to the current <li>.
                $wrapper.stop(true, true).show();
              }
            },
            function() {
              if (window.innerWidth >= 1200) {
                var $item = $(this);
                var $wrapper = $item.children('.js-dropdown-menu-wrapper');

                // Remove hover only from the current <li>.
                $item.removeClass('hover');

                // Close only its own dropdown wrapper.
                $wrapper.stop(true, true).hide();
              }
            }
          );

        });

        //Mobile
        $('.navbar-nav li.dropdown > a.js-dropdown-toggle').on('click', function(e) {
          if (window.innerWidth < 1200) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var $toggle = $(this);
            var $dropdown = $toggle.closest('.dropdown');
            var $menuWrapper = $toggle.siblings('.dropdown-menu-wrapper');
            var $menu = $menuWrapper.children('.dropdown-menu');
            var isOpen = $menuWrapper.hasClass('hover');

            // Close all other dropdowns.
            $('.navbar-nav li.dropdown')
              .not($dropdown)
              .each(function() {
                var $otherDropdown = $(this);
                var $otherWrapper = $otherDropdown.children('.dropdown-menu-wrapper');
                var $otherMenu = $otherWrapper.children('.dropdown-menu');

                $otherMenu.stop(true, true).hide(300);
                $otherWrapper.removeClass('hover');

                $otherDropdown
                  .children('.js-dropdown-toggle')
                  .attr('aria-expanded', 'false');
              });

            if (isOpen) {
              $menu.stop(true, true).fadeOut(200);
              $menuWrapper.removeClass('hover');
              $toggle.attr('aria-expanded', 'false');
            } else {
              $menu.stop(true, true).fadeIn(200);
              $menuWrapper.addClass('hover');
              $toggle.attr('aria-expanded', 'true');
            }
          }
        });


        ////////////////////////////////////////////////////////////////////////////////////
        // Reset mobile menu when resizing to desktop
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery(function($) {
          $(window).on('resize', function() {
            if(window.innerWidth >= 1200) {
              $('.navbar-collapse.mobile').removeClass('active');
              $('.navbar-toggler').removeClass('collapsed active');
              $('body').removeClass('navbar-active');
            }
          });
        });


        ////////////////////////////////////////////////////////////////////////////////////
        // Accordion
        ////////////////////////////////////////////////////////////////////////////////////
        $('.section-flexi-product-hero__image-accordion-item').on('click', function() {
          $(this)
            .addClass('active')
            .siblings()
            .removeClass('active');
        });

        // accordion switcher
        initFilterPanels({
          block: '.js-flexi-accordion-tabs',
          filter: '.js-flexi-accordion-filter',
          panelsContainer: '.js-flexi-accordion-panels',
          panel: '.js-flexi-accordion-panel',
          indexAttr: 'accordion-index',
          timerDataKey: 'accordionHideTimer'
        });





        ////////////////////////////////////////////////////////////////////////////////////
        // Two Panel Block - Flickity
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery(function ($) {
          $('.js-two-panel-slider').each(function () {
            var $slider = $(this);
            var $carousel = $slider.find('.js-two-panel-carousel');
            var $tabs = $slider.find('.js-two-panel-tab');
            var $contents = $slider.find('.js-two-panel-content');

            $carousel.flickity({
              cellAlign: 'left',
              contain: true,
              wrapAround: true,
              imagesLoaded: true,
              prevNextButtons: false,
              pageDots: false,
              draggable: true
            });

            function setActiveSlide(index) {
              index = parseInt(index, 10);

              $tabs.removeClass('is-active');
              $tabs.filter('[data-slide="' + index + '"]').addClass('is-active');

              $contents.removeClass('is-active');
              $contents.filter('[data-slide="' + index + '"]').addClass('is-active');
            }

            $tabs.on('click', function () {
              var index = $(this).data('slide');

              $carousel.flickity('select', index);
              setActiveSlide(index);
            });

            $carousel.on('change.flickity', function (event, index) {
              setActiveSlide(index);
            });
          });
        });




        ////////////////////////////////////////////////////////////////////////////////////
        // Our Brands - Flickity
        ////////////////////////////////////////////////////////////////////////////////////
        (function ($) {
          function initOurBrandsSliders() {
            $('.js-flexi-our-brands-slider:not(.is-initialized)').each(function () {
              var $slider = $(this);

              if (typeof $.fn.flickity === 'undefined') {
                return;
              }

              $slider.addClass('is-initialized');

              $slider.flickity({
                cellAlign: 'left',
                contain: false,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
              });

              var $section = $slider.closest('.flexi-our-brands');

              $section.find('.flexi-our-brands__arrow--prev').on('click', function () {
                $slider.flickity('previous');
              });

              $section.find('.flexi-our-brands__arrow--next').on('click', function () {
                $slider.flickity('next');
              });
            });
          }

          $(document).ready(initOurBrandsSliders);
          $(window).on('load', initOurBrandsSliders);
        })(jQuery);



        ////////////////////////////////////////////////////////////////////////////////////
        // Milestones
        ////////////////////////////////////////////////////////////////////////////////////
        (function ($) {
          'use strict';

          var desktopHoverQuery = window.matchMedia('(min-width: 1200px)');

          function getDefaultMilestoneIndex($block) {
            var defaultIndex = $block.data('default-milestone-index');

            return defaultIndex !== undefined && defaultIndex !== '' ? defaultIndex : 0;
          }

          function alignActiveYear($block, $year) {
            var $years = $year.closest('.flexi-milestones-block__years');
            var $mobileDescriptions = $block.find('.flexi-milestones-block__mobile-descriptions:visible').first();
            var $activeDescription = $mobileDescriptions.find('.js-flexi-milestones-mobile-description.active').first();
            var $descriptionContent = $activeDescription.find('p').first();

            if (!$mobileDescriptions.length || !$activeDescription.length) {
              return;
            }

            scrollActiveIntoView($years, $year, $descriptionContent.length ? $descriptionContent : $activeDescription);
          }

          function queueActiveYearAlignment($block, $year) {
            window.requestAnimationFrame(function () {
              alignActiveYear($block, $year);
            });
          }

          function setActiveMilestone($block, index) {
            var $items = $block.find('.js-flexi-milestones-item');
            var $years = $block.find('.js-flexi-milestones-year');
            var $descriptions = $block.find('.js-flexi-milestones-description');
            var $mobileDescriptions = $block.find('.js-flexi-milestones-mobile-description');
            var $images = $block.find('.js-flexi-milestones-image');
            var $activeYear = $years.filter('[data-milestone-index="' + index + '"]');

            $items.removeClass('active');

            $items
              .filter('[data-milestone-index="' + index + '"]')
              .addClass('active');

            $years
              .removeClass('active')
              .attr('aria-selected', 'false');

            $activeYear
              .addClass('active')
              .attr('aria-selected', 'true');

            $descriptions
              .removeClass('active')
              .attr('aria-hidden', 'true');

            $descriptions
              .filter('[data-milestone-index="' + index + '"]')
              .addClass('active')
              .attr('aria-hidden', 'false');

            $mobileDescriptions
              .removeClass('active')
              .attr('aria-hidden', 'true');

            $mobileDescriptions
              .filter('[data-milestone-index="' + index + '"]')
              .addClass('active')
              .attr('aria-hidden', 'false');

            $images
              .removeClass('active')
              .attr('aria-hidden', 'true');

            $images
              .filter('[data-milestone-index="' + index + '"]')
              .addClass('active')
              .removeAttr('aria-hidden');

            queueActiveYearAlignment($block, $activeYear);
          }

          function initMilestones() {
            $('.js-flexi-milestones').each(function () {
              var $block = $(this);
              var defaultIndex = getDefaultMilestoneIndex($block);

              setActiveMilestone($block, defaultIndex);

              $block.on('mouseenter', '.js-flexi-milestones-year', function () {
                if (!desktopHoverQuery.matches) { return; }
                setActiveMilestone($block, $(this).data('milestone-index'));
              });

              $block.on('click', '.js-flexi-milestones-year', function () {
                setActiveMilestone($block, $(this).data('milestone-index'));
              });

              $block.on('click', '.js-flexi-milestones-reset', function () {
                setActiveMilestone($block, defaultIndex);
              });

              $block.on('keydown', '.js-flexi-milestones-year', function (event) {
                if (event.key !== 'Enter' && event.key !== ' ') {
                  return;
                }

                event.preventDefault();
                setActiveMilestone($block, $(this).data('milestone-index'));
              });

              $(window).on('resize.flexiMilestones orientationchange.flexiMilestones', function () {
                var $activeYear = $block.find('.js-flexi-milestones-year.active').first();

                if ($activeYear.length) {
                  queueActiveYearAlignment($block, $activeYear);
                }
              });
            });
          }

          $(initMilestones);
        })(jQuery);




        ////////////////////////////////////////////////////////////////////////////////////
        // Gallery Carousel
        ////////////////////////////////////////////////////////////////////////////////////
        function initGalleryCarousel($wrapper, options = {}) {
          const settings = $.extend(
            {
              autoplay: true,
              autoplayDelay: 3000,
              slideDuration: 360,
              mobileSlideDuration: 320,
              caption: true,
              dots: true,
              cursorFollowSpeed: 0.45
            },
            options
          );

          const $viewport = $wrapper.find('.custom-carousel-viewport');
          const $carousel = $wrapper.find('.custom-carousel');
          const $cells = $carousel.children('.carousel-cell');
          const $prevBtn = $wrapper.find('.carousel-prev');
          const $nextBtn = $wrapper.find('.carousel-next');
          const $captionBelow = $wrapper.find('.carousel-caption-below');
          const $captionOutput = $captionBelow.find('#active-caption');

          let autoPlayTimer = null;
          const autoPlayDelay = settings.autoplayDelay;

          let cellWidth = $cells.outerWidth(true);
          const totalCells = $cells.length;

          const $dotsTrack = $wrapper.find('.js-carousel-dots');
          let $dots = $();

          // Clone for infinite loop.
          $carousel.prepend($cells.clone());
          $carousel.append($cells.clone());

          let currentIndex = totalCells;
          let isAnimating = false;
          let animFrame = null;
          let isDragging = false;
          let startX = 0;
          let dragDelta = 0;
          let velocity = 0;
          let lastX = 0;
          let lastTime = 0;
          let resizeTimer = null;

          function getSlidePosition(index) {
            const $targetCell = $carousel.children('.carousel-cell').eq(index);

            if (!$targetCell.length) {
              return -index * cellWidth;
            }

            const carouselRect = $carousel[0].getBoundingClientRect();
            const targetRect = $targetCell[0].getBoundingClientRect();

            return -(targetRect.left - carouselRect.left);
          }

          function refreshCarouselPosition() {
            const realIndex = ((currentIndex % totalCells) + totalCells) % totalCells;

            cancelAnimationFrame(animFrame);
            isAnimating = false;
            cellWidth = $carousel.children('.carousel-cell').outerWidth(true);
            currentIndex = totalCells + realIndex;

            $carousel.css('transition', 'none');
            $carousel.css('transform', `translateX(${getSlidePosition(currentIndex)}px)`);
            updateCaption();
          }

          function startAutoplay() {
            if (!settings.autoplay) return;

            stopAutoplay();
            autoPlayTimer = setInterval(function () {
              if (!isDragging && !isAnimating) {
                goToSlide(currentIndex + 1);
              }
            }, autoPlayDelay);
          }

          function stopAutoplay() {
            if (autoPlayTimer) {
              clearInterval(autoPlayTimer);
              autoPlayTimer = null;
            }
          }

          function buildDots() {
            if (!settings.dots || !$dotsTrack.length) {
              $wrapper.find('.carousel-dots').addClass('d-none');
              return;
            }

            $dotsTrack.empty();

            for (let i = 0; i < totalCells; i++) {
              $dotsTrack.append(
                `<button type="button" class="carousel-dot" data-index="${i}" aria-label="Go to slide ${i + 1}"></button>`
              );
            }

            $dots = $dotsTrack.find('.carousel-dot');
          }

          function updateDots() {
            if (!settings.dots || !$dots.length) return;

            const realIndex = ((currentIndex % totalCells) + totalCells) % totalCells;
            $dots.removeClass('is-active').eq(realIndex).addClass('is-active');
          }

          function updateCaption() {
            const realIndex = ((currentIndex % totalCells) + totalCells) % totalCells;
            const caption = $cells.eq(realIndex).find('.carousel-caption').text();
            const pageNumber = `${realIndex + 1}/${totalCells} `;

            if (settings.caption && $captionOutput.length) {
              $captionBelow.removeClass('d-none');
              $captionOutput.html('<span class="_h5">' + pageNumber + '</span>' + caption);
            } else {
              $captionBelow.addClass('d-none');
            }

            updateActiveCell();
            updateDots();
          }

          function updateActiveCell() {
            const realIndex = ((currentIndex % totalCells) + totalCells) % totalCells;

            $carousel.find('.carousel-cell').removeClass('active');
            $cells.eq(realIndex).addClass('active');
          }

          function freezePosition() {
            const style = window.getComputedStyle($carousel[0]);
            const matrix = style.transform;

            let currentX = getSlidePosition(currentIndex);

            if (matrix && matrix !== 'none') {
              const values = matrix.match(/matrix.*\((.+)\)/)[1].split(',');
              currentX = parseFloat(values[4]);
            }

            $carousel.css({
              transition: 'none',
              transform: `translateX(${currentX}px)`
            });

            $carousel[0].offsetHeight;
            return currentX;
          }

          function goToSlide(targetIndex) {
            if (isAnimating) return;

            isAnimating = true;

            const currentTransform = freezePosition();
            const distance = getSlidePosition(targetIndex);
            const diff = distance - currentTransform;
            const duration =
              window.innerWidth < 992 ? settings.mobileSlideDuration : settings.slideDuration;

            let start = null;

            function animateSlide(timestamp) {
              if (!start) start = timestamp;

              const progress = Math.min((timestamp - start) / duration, 1);
              const eased = 1 - Math.pow(1 - progress, 3);
              const pos = currentTransform + diff * eased;

              $carousel.css('transform', `translateX(${pos}px)`);

              if (progress < 1) {
                animFrame = requestAnimationFrame(animateSlide);
              } else {
                currentIndex = targetIndex;

                if (currentIndex >= totalCells * 2) currentIndex = totalCells;
                if (currentIndex < totalCells) currentIndex = totalCells * 2 - 1;

                $carousel.css('transition', 'none');
                $carousel.css('transform', `translateX(${getSlidePosition(currentIndex)}px)`);
                updateCaption();
                isAnimating = false;
              }
            }

            animFrame = requestAnimationFrame(animateSlide);
          }

          buildDots();

          $nextBtn.on('click', function () {
            goToSlide(currentIndex + 1);
          });

          $prevBtn.on('click', function () {
            goToSlide(currentIndex - 1);
          });

          $carousel.on('mousedown touchstart', function (e) {
            if (e.type === 'mousedown' && e.button !== 0) return;
            if (isAnimating) return;

            isDragging = true;
            $carousel.css('transition', 'none');
            startX = e.type === 'touchstart' ? e.originalEvent.touches[0].clientX : e.clientX;
            lastX = startX;
            lastTime = Date.now();
            cancelAnimationFrame(animFrame);
          });

          $(document).on('mousemove touchmove', function (e) {
            if (!isDragging) return;

            const x = e.type === 'touchmove' ? e.originalEvent.touches[0].clientX : e.clientX;
            const now = Date.now();
            const delta = x - lastX;

            velocity = delta / (now - lastTime);
            lastX = x;
            lastTime = now;
            dragDelta = x - startX;

            const offset = getSlidePosition(currentIndex) + dragDelta;
            $carousel.css('transform', `translateX(${offset}px)`);
          });

          $(document).on('mouseup touchend', function () {
            if (!isDragging) return;

            isDragging = false;

            const momentum = velocity * 250;
            const totalMove = dragDelta + momentum;

            let targetIndex = currentIndex;
            if (totalMove < -70) targetIndex++;
            else if (totalMove > 70) targetIndex--;

            goToSlide(targetIndex);

            dragDelta = 0;
            velocity = 0;
          });

          $dotsTrack.on('click', '.carousel-dot', function () {
            if (!settings.dots) return;

            const realIndex = parseInt(this.dataset.index, 10);
            goToSlide(totalCells + realIndex);
          });

          $(window).on('resize', function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
              requestAnimationFrame(function () {
                refreshCarouselPosition();
                setTimeout(refreshCarouselPosition, 300);
                setTimeout(refreshCarouselPosition, 650);
              });
            }, 150);
          });

          $carousel.css('transform', `translateX(${getSlidePosition(currentIndex)}px)`);
          updateCaption();
          updateDots();
          startAutoplay();

          const $cursor = $wrapper.find('.custom-carousel-cursor');

          let mouseX = 0;
          let mouseY = 0;
          let cursorX = 0;
          let cursorY = 0;

          function setMouseFromEvent(e, snapToPointer = false) {
            const evt = e.type.startsWith('touch') ? e.originalEvent.touches[0] : e;
            const rect = $viewport[0].getBoundingClientRect();

            mouseX = evt.clientX - rect.left;
            mouseY = evt.clientY - rect.top;

            if (snapToPointer) {
              cursorX = mouseX;
              cursorY = mouseY;
            }
          }

          $viewport.on('mousemove touchmove', function (e) {
            setMouseFromEvent(e);
          });

          $viewport.on('mouseenter', function (e) {
            setMouseFromEvent(e, true);
            $cursor.css('opacity', '1');
          });

          $viewport.on('mouseleave', function () {
            $cursor.css('opacity', '0');
          });

          $wrapper.on('mouseenter', stopAutoplay);
          $wrapper.on('mouseleave', startAutoplay);
          $carousel.on('mousedown touchstart', stopAutoplay);

          $(document).on('mouseup touchend', function () {
            if (!isDragging) {
              startAutoplay();
            }
          });

          function animateCursor() {
            cursorX += (mouseX - cursorX) * settings.cursorFollowSpeed;
            cursorY += (mouseY - cursorY) * settings.cursorFollowSpeed;

            $cursor.css(
              'transform',
              `translate(${cursorX - $cursor.outerWidth() / 2}px, ${cursorY - $cursor.outerHeight() / 2}px)`
            );

            requestAnimationFrame(animateCursor);
          }

          animateCursor();
        }

        $('.section-flexi-gallery-carousel .custom-carousel-wrapper').each(function () {
          initGalleryCarousel($(this), {
            autoplay: false,
            autoplayDelay: 3000,
            slideDuration: 360,
            mobileSlideDuration: 320,
            caption: true,
            dots: false,
            cursorFollowSpeed: 0.45
          });
        });






        ////////////////////////////////////////////////////////////////////////////////////
        // Vacancy
        ////////////////////////////////////////////////////////////////////////////////////
        (function () {
            const vacancySections = document.querySelectorAll(
                '.section-flexi-vacancies-block'
            );

            vacancySections.forEach((section) => {
                const loadMore = section.querySelector('[data-vacancies-load-more]');

                if (!loadMore) {
                    return;
                }

                const loadMoreWrapper = loadMore.closest(
                    '.flexi-vacancies-block__load-more-wrapper'
                );

                const vacancies = Array.from(
                    section.querySelectorAll('[data-vacancies-list] .is-hidden')
                );

                if (!vacancies.length) {
                    if (loadMoreWrapper) {
                        loadMoreWrapper.hidden = true;
                    } else {
                        loadMore.hidden = true;
                    }

                    return;
                }

                loadMore.addEventListener('click', () => {
                    const nextVacancies = vacancies.splice(0, 6);

                    nextVacancies.forEach((vacancy) => {
                        vacancy.hidden = false;
                        vacancy.classList.remove('is-hidden');
                    });

                    if (!vacancies.length) {
                        if (loadMoreWrapper) {
                            loadMoreWrapper.hidden = true;
                        } else {
                            loadMore.hidden = true;
                        }
                    }
                });
            });
        })();




        ////////////////////////////////////////////////////////////////////////////////////
        // Logo Slider
        ////////////////////////////////////////////////////////////////////////////////////
        function onReady(fn) {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
          } else {
            fn(); // DOM already loaded
          }
        }

        onReady(flexiLogoSliderinit);

        let resizeTimeout;

        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(() => {
            if (flexiLogoSliderInstance) {
              // Wait until slider finishes animating
              flexiLogoSliderInstance.once('settle', () => {
                flexiLogoSliderinit();
              });

              // Force it to settle if it's mid-transition
              flexiLogoSliderInstance.select(
                flexiLogoSliderInstance.selectedIndex,
                false,
                true // instant
              );
            } else {
              flexiLogoSliderinit();
            }
          }, 300);
        });




        ////////////////////////////////////////////////////////////////
        // TABBED DYNAMIC CONTENT
        ////////////////////////////////////////////////////////////////
        (function ($) {
          'use strict';

          function alignActiveTabbedDynamicContentTab($tab) {
            var $tabs = $tab.closest('.tabbed-dynamic-content__tabs');
            var $block = $tab.closest('.tabbed-dynamic-content');
            var $activeImage = $block.find('.tabbed-dynamic-content__image.is-active').first();

            scrollActiveIntoView($tabs, $tab, $activeImage, { snapAfter: true });
          }

          function queueActiveTabbedDynamicContentTabAlignment($tab) {
            window.requestAnimationFrame(function () {
              alignActiveTabbedDynamicContentTab($tab);
            });
          }

          function setActiveTabbedDynamicContentTab($block, index) {
            var $tab = $block.find('.tabbed-dynamic-content__tab[data-tab="' + index + '"]').first();
            var $reset = $block.find('.js-flexi-tabbed-dynamic-content-reset');
            var $content;
            var $images;

            if (!$tab.length) {
              return;
            }

            $block
              .find('.tabbed-dynamic-content__tab')
              .removeClass('is-active');

            $tab.addClass('is-active');

            $content = $block.find('.tabbed-dynamic-content__text');
            $content.removeClass('is-active');
            $content.filter('[data-content="' + index + '"]').addClass('is-active');

            $images = $block.find('.tabbed-dynamic-content__image');
            $images.removeClass('is-active');
            $images.filter('[data-image="' + index + '"]').addClass('is-active');

            $reset.toggleClass('is-hidden', Number(index) === 0);

            queueActiveTabbedDynamicContentTabAlignment($tab);
          }

          $('.tabbed-dynamic-content__tab').on('click', function () {
            var $tab = $(this);
            var $block = $tab.closest('.tabbed-dynamic-content');

            setActiveTabbedDynamicContentTab($block, $tab.data('tab'));
          });

          $('.js-flexi-tabbed-dynamic-content-reset').on('click', function () {
            var $block = $(this).closest('.tabbed-dynamic-content');

            setActiveTabbedDynamicContentTab($block, 0);
          });

          $(window).on('load resize orientationchange', function () {
            $('.tabbed-dynamic-content__tab.is-active').each(function () {
              queueActiveTabbedDynamicContentTabAlignment($(this));
            });
          });

          $('.tabbed-dynamic-content').each(function () {
            var $block = $(this);
            var $activeTab = $block.find('.tabbed-dynamic-content__tab.is-active').first();

            if ($activeTab.length) {
              $block
                .find('.js-flexi-tabbed-dynamic-content-reset')
                .toggleClass('is-hidden', Number($activeTab.data('tab')) === 0);
            }
          });
        })(jQuery);




        ////////////////////////////////////////////////////////////////
        // Ticker Tape
        ////////////////////////////////////////////////////////////////
        (function ($) {
          'use strict';

          if (typeof window.initFlexiTickerTape === 'function') { window.initFlexiTickerTape(); }

          $(window).on('resize', function () {
            $('.js-marquee-track').each(function () {
              $(this).removeData('marqueeInit');
            });
            if (typeof window.initFlexiTickerTape === 'function') { window.initFlexiTickerTape(); }
          });
        })(jQuery);





        ////////////////////////////////////////////////////////////////
        // Team Cards
        ////////////////////////////////////////////////////////////////
        (function ($) {
          'use strict';

          $('.flexi-team-cards').each(function(index) {
            var $teamCards = $(this);
            var $images = $teamCards.find('.team-image');
            var $wrapper = $teamCards.find('.team-image-wrapper');
            var $accordion = $teamCards.find('.accordion');
            var accordionId = 'accordion-' + index;

            $accordion.attr('id', accordionId);

            $accordion.find('.accordion-collapse').each(function() {
              $(this).attr('data-bs-parent', '#' + accordionId);
            });

            $images.hide().first().addClass('active').show();

            function setWrapperHeight() {
              var contentHeight = $wrapper.find('.team-image.active').outerHeight() || 0;
              //$wrapper.height(contentHeight);
            }

            $accordion.on('show.bs.collapse', '.accordion-collapse', function () {
              var $item = $(this).closest('.accordion-item');
              var index = $item.index();

              $images.stop(true, true).removeClass('active').hide();
              $images.eq(index).stop(true, true).addClass('active').show();

              setTimeout(setWrapperHeight, 350);
            });

            setWrapperHeight();
            $(window).on('resize', setWrapperHeight);
          });
        })(jQuery);












        //////////////////////////////////////////////////////////////
        // Thicker Gutter for two column, copy and gravity form siblings
        //////////////////////////////////////////////////////////////
        $('.section-flexi-double-column-content').each(function() {
          const $copyColumn = $(this).find('.col-lg-6:has(.section-copy-block)');
          const $formColumn = $(this).find('.col-lg-6:has(.gform_wrapper)');
          if (
              $copyColumn.length === 1 &&
              $formColumn.length === 1 &&
              $copyColumn[0] !== $formColumn[0] &&
              $copyColumn.parent()[0] === $formColumn.parent()[0]
          ) {
              $(this).addClass('has-copy-form-layout');
          }
        });




        //////////////////////////////////////////////////////////////
        // select/chosen placeholder state
        //////////////////////////////////////////////////////////////
        function updateChosenPlaceholderState($select) {
          const isPlaceholder = !$select.val();
          $select.toggleClass('is-placeholder-selected', isPlaceholder);
          $select
              .next('.chosen-container')
              .toggleClass('is-placeholder-selected', isPlaceholder);
        }

        $(document).ready(function() {
          $('.gform_wrapper select').each(function() {
              updateChosenPlaceholderState($(this));
          });
          $(document).on('change', '.gform_wrapper select', function() {
              updateChosenPlaceholderState($(this));
          });
        });







        //////////////////////////////////////////////////////////////
        // Contact Us Filter
        //////////////////////////////////////////////////////////////
        initFilterPanels({
          block: '.js-flexi-contact-us',
          filter: '.js-flexi-contact-us-filter',
          panelsContainer: '.js-flexi-contact-us-panels',
          panel: '.js-flexi-contact-us-panel',
          indexAttr: 'contact-index',
          timerDataKey: 'contactHideTimer'
        });






        




//////////////////////////////////////////////////////////////
// Quick Link underline mask
//////////////////////////////////////////////////////////////
(() => {
    const descenderPattern = /[gjpqy]/;
    const lgDescenderOffset = {
        g: 0.03,
        j: 0.07,
        p: 0.03,
        q: 0.05,
        y: 0.11,
    };

    const createWaveMask = (heading) => {
        const text = heading.dataset.text || heading.textContent.trim();
        const styles = getComputedStyle(heading);
        const fontSize = parseFloat(styles.fontSize);
        const width = Math.ceil(heading.offsetWidth);
        const height = Math.ceil(heading.offsetHeight);

        if (!descenderPattern.test(text)) {
            heading.style.removeProperty('--wave-mask');
            return;
        }

        if (!width || !height || !fontSize) {
            return;
        }

        const scale = window.devicePixelRatio || 1;
        const canvas = document.createElement('canvas');
        canvas.width = width * scale;
        canvas.height = height * scale;

        const ctx = canvas.getContext('2d');
        const font = [
            styles.fontStyle,
            styles.fontVariant,
            styles.fontWeight,
            `${fontSize}px`,
            styles.fontFamily,
        ].join(' ');

        ctx.scale(scale, scale);
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, width, height);
        ctx.font = font;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;

        if ('letterSpacing' in ctx) {
            ctx.letterSpacing = styles.letterSpacing;
        }

        const metrics = ctx.measureText(text);
        const ascent = metrics.actualBoundingBoxAscent || fontSize * 0.8;
        const descent = metrics.actualBoundingBoxDescent || fontSize * 0.2;
        const baseline = (height / 2) + ((ascent - descent) / 2);
        const strokeWidth = Math.max(6, fontSize * 0.06);
        const maskOffsetX = Math.max(1, fontSize * 0.005);
        const isXxlDown = window.matchMedia('(max-width: 1440px)').matches;
        const isLgDown = window.matchMedia('(max-width: 991.98px)').matches;

        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = '#000';
        ctx.strokeStyle = '#000';
        ctx.lineWidth = strokeWidth;

        if (isXxlDown) {
            const letterSpacing = parseFloat(styles.letterSpacing) || 0;
            const textLeft = ((width - metrics.width) / 2) + maskOffsetX;

            ctx.textAlign = 'left';

            Array.from(text).forEach((character, index) => {
                if (!descenderPattern.test(character)) {
                    return;
                }

                const before = text.slice(0, index);
                const characterOffsetX = isLgDown
                    ? fontSize * (lgDescenderOffset[character] || 0.12)
                    : 0;
                const characterX = textLeft + ctx.measureText(before).width + (letterSpacing * index) + characterOffsetX;

                ctx.strokeText(character, characterX, baseline);
                ctx.fillText(character, characterX, baseline);
            });
        } else {
            ctx.strokeText(text, (width / 2) + maskOffsetX, baseline);
            ctx.fillText(text, (width / 2) + maskOffsetX, baseline);
        }

        heading.style.setProperty('--wave-mask', `url("${canvas.toDataURL('image/png')}")`);
    };

    const createWaveMasks = () => {
        document.querySelectorAll('._main_heading').forEach(createWaveMask);
    };

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(createWaveMasks);
    } else {
        window.addEventListener('load', createWaveMasks);
    }

    window.addEventListener('resize', createWaveMasks);
})();


jQuery(window).on('load', function() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Flexible Content: Dynamic Selective Content Module
    ////////////////////////////////////////////////////////////////////////////////////
    flexi_dynamic_selective_content_module();

});


















        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        if ($('#js-form-contact').length) {
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                // TEMPLATE: Remove this return to enable Mandrill form submission
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // TEMPLATE: Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // TEMPLATE: MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token
        } // if #js-form-contact exists

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
